const PanelSizes = {
  main: {
    order: 1,
    min: 30,
    max: 100,
    defaultSize: 100,
  },
  sidebar: {
    order: 2,
    min: 25,
    max: 70,
    defaultSize: 30,
  },
};

export default PanelSizes;
